/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable react/no-array-index-key */
import { BigNumber } from 'ethers'
import React, { useEffect, useRef } from 'react'
import { getReadableNumber } from 'src/helpers/getReadableNumber'
import { Spring } from 'react-spring/renderprops'
import './NumberFlippingAnimation.scss'

// Customized version of https://github.com/heyman333/react-animated-numbers/blob/master/index.jsx

const NUMBERS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]

interface IProps {
  numberToFlip: BigNumber
  numberHeight: number
  numberHeightLengthType: 'px' | 'rem'
  nbDecimals: number
  includeComma?: boolean
  prefix?: string
}

export function NumberFlippingAnimation({
  numberToFlip,
  prefix,
  numberHeight,
  numberHeightLengthType,
  nbDecimals,
  includeComma = true,
}: IProps) {
  const { readableNumber, smallerThanSymbol } = getReadableNumberStr(numberToFlip, nbDecimals)
  const prevNumber = usePrevious(readableNumber)
  const animateToNumbersString = getAnimateToNumberStr(readableNumber, nbDecimals)
  const prevNumberString = String(Math.abs(prevNumber))
  const animateToNumbersArr: Array<number | string> = Array.from(animateToNumbersString, (val) => {
    if (isNaN(parseFloat(val))) {
      return val
    } else {
      return parseFloat(val)
    }
  })
  const prevNumberersArr: Array<number | string> = Array.from(prevNumberString, Number)

  if (includeComma && readableNumber >= 1000) {
    const numberStrToCommify = parseInt(animateToNumbersString, 10).toString()
    const reducedArray = new Array(Math.ceil(numberStrToCommify.length / 3)).fill(0)

    const startReducedArray = new Array(Math.ceil(prevNumberString.length / 3)).fill(0)

    console.log({ reducedArray, startReducedArray })

    reducedArray.map((__, index) => {
      if (index === 0) {
        return
      }

      animateToNumbersArr.splice(numberStrToCommify.length - index * 3, 0, ',')
    })

    startReducedArray.map((__, index) => {
      if (index === 0) {
        return
      }

      prevNumberersArr.splice(prevNumberString.length - index * 3, 0, ',')
    })
  }

  const animatedNumbers = () => {
    return animateToNumbersArr.map((n, index) => {
      // n could be a comma or a dot
      if (typeof n === 'string') {
        return (
          <div className="number-flipping-animation__item" key={index}>
            {n}
          </div>
        )
      }

      return (
        <div
          key={index}
          style={{
            height: numberHeight + numberHeightLengthType,
            overflow: 'hidden',
          }}
          className="number-flipping-animation__item"
        >
          <Spring
            from={{
              transform: 'translateY(0rem)',
            }}
            to={{
              transform: `translateY(-${numberHeight * n}${numberHeightLengthType})`,
            }}
          >
            {(springProps) =>
              NUMBERS.map((nb, i) => (
                <div key={i} style={{ ...springProps }}>
                  {nb}
                </div>
              ))
            }
          </Spring>
        </div>
      )
    })
  }

  return (
    <div className="number-flipping-animation">
      <span className="number-flipping-animation__item">{`${smallerThanSymbol}${prefix}`}</span>
      <span className="number-flipping-animation__numbers_container">
        {animatedNumbers()}
        {/* {readableNumber.toString()} */}
      </span>
    </div>
  )
}

const usePrevious = (value) => {
  const ref = useRef()

  useEffect(() => {
    ref.current = value
  })

  if (typeof ref.current === 'undefined') {
    return 0
  }

  return ref.current
}

function getReadableNumberStr(number: BigNumber, nbDecimals: number) {
  const readableNumberStr: string = getReadableNumber(number, nbDecimals)
  let readableNumber: number
  let smallerThanSymbol = ''

  if (readableNumberStr.includes('<')) {
    readableNumber = parseFloat(readableNumberStr.substr(readableNumberStr.indexOf('<') + 1))
    smallerThanSymbol = '<'
  } else {
    readableNumber = parseFloat(readableNumberStr)
  }

  return { readableNumber, readableNumberStr, smallerThanSymbol }
}

/**
 * Returns the `nb` in string format with the given number of decimals
 */
function getAnimateToNumberStr(nb: number, nbDecimals: number) {
  let res = Math.abs(nb).toFixed(nbDecimals)
  const periodIndex = res.indexOf('.')

  if (periodIndex === -1) {
    // Number does not have decimals
    res += `.${Array(nbDecimals).fill('0').join('')}`
  } else {
    // Number has decimals
    let decimalPartStr = res.substr(periodIndex + 1)

    // Add/remove the remaining decimals if needed
    const nbMissingDecimals = nbDecimals - decimalPartStr.length
    if (nbMissingDecimals > 0) {
      res += Array(nbMissingDecimals).fill('0').join('')
    } else if (nbMissingDecimals < 0) {
      // There are too many decimals. Need to remove the extra ones
      decimalPartStr = Math.round(
        parseFloat(decimalPartStr) / 10 ** (nbMissingDecimals * -1),
      ).toString()
      const integerPart = res.substr(0, periodIndex)
      res = `${integerPart}.${decimalPartStr}`
    }
  }

  return res
}
